import {
  AcademicRecordEdit,
  AcademicRecordShow
} from 'pages/academic/academic_records';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'graduate_academic_records',
  route: 'secretary/graduate/academic_records',
  label: 'Histórico acadêmico',
  show: AcademicRecordShow,
  edit: AcademicRecordEdit,
  actions: ['show', 'edit', 'list', 'delete'],
  parentName: 'secretary'
};

export default generateResources(resource);
